import UserPopUp from './UserPopUp';

export default UserPopUp;
